import PropTypes from 'prop-types'
import React from 'react'
import Header from 'components/Header'
import { ROUTES } from 'constants/routes'

const FaqLayoutHeader = ({ showSidebarToggle = false }) => (
  <Header
    showSidebarToggle={showSidebarToggle}
    hasBalance={false}
    faqPath={ROUTES.CABINET_FAQ}
    openFaqInNewTab={false}
    alwaysShowActions
  />
)

FaqLayoutHeader.propTypes = {
  showSidebarToggle: PropTypes.bool,
}

export default FaqLayoutHeader
